import { useState } from "react";

import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface CopyableGuidProps {
  label?: string;
  value: string;
}

export default function CopyableGuid({ label, value }: CopyableGuidProps) {
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Typography variant="body2" color="text.secondary" fontFamily="monospace">
        {label ? `${label}: ` : ""}
        {value}
      </Typography>
      <Tooltip title={copied ? "Copied!" : "Copy GUID"}>
        <IconButton size="small" onClick={handleCopy} sx={{ color: "text.secondary" }}>
          {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
